<template>
  <!-- Server-rendered HTML from limit_reached.locations(_paypal)_html.
       Content is fully controlled by Ruby i18n; no user input — safe for v-html.
       The contact-support anchor has id="js-open-intercom" which Intercom's
       custom_launcher_selector hooks into automatically. -->
  <AppAlert
    v-if="!snoozed"
    variant="warning"
    dismissible
    @dismiss="snooze">
    <!-- eslint-disable vue/no-v-html -->
    <span v-html="data.html" />
    <!-- eslint-enable vue/no-v-html -->
  </AppAlert>
</template>

<script setup>
import { ref } from 'vue'
import { AppAlert } from '@/components/ui'
import { useGlobalStore } from '@/stores/global'
import { getFromStorage, saveToStorage } from '@/helpers/storage'

// The persistent banner pushes every page down; let users snooze it per
// browser and organization. It reappears after a week — the limit is still
// a billing state to resolve, so this is a snooze, not a dismissal.
const SNOOZE_MS = 7 * 24 * 60 * 60 * 1000

defineProps({
  data: { type: Object, required: true }
})

const globalStore = useGlobalStore()
const storageKey = `org_limit_alert_snoozed_at_${globalStore.organization?.obfuscatedId || 'unknown'}`

const snoozedAt = getFromStorage(storageKey)
const snoozed = ref(!!snoozedAt && Date.now() - snoozedAt < SNOOZE_MS)

function snooze() {
  saveToStorage(storageKey, Date.now())
  snoozed.value = true
}
</script>
